import { FilterState } from '@/components/filters/index';
import { SidebarFiltersList } from '@/components/filters/SidebarFiltersList';
import {
    BeerStyles,
    Categories,
    PackagingTypes,
    Vendors,
    Volumes,
} from '@/types';
import React from 'react';

interface FiltersProps {
    isOpen?: boolean;
    onClose: () => void;
    categoriesById: Categories;
    beerStylesById: BeerStyles;
    vendorsById: Vendors;
    packagingTypesById: PackagingTypes;
    volumesById: Volumes;
    filters: FilterState;
    setFilters: React.Dispatch<React.SetStateAction<FilterState>>;
    onApply: () => void;
}

export function Filters({
    isOpen,
    onClose,
    categoriesById,
    beerStylesById,
    vendorsById,
    packagingTypesById,
    volumesById,
    filters,
    setFilters,
    onApply,
}: FiltersProps) {
    const handleToggleFilter = (key: keyof FilterState, value: string) => {
        setFilters((prev: FilterState) => {
            const current = prev[key] as string[] | undefined;
            const exists = current && current.includes(value);
            return {
                ...prev,
                [key]: exists
                    ? current.filter((item) => item !== value)
                    : current
                      ? [...current, value]
                      : [value],
            };
        });
    };

    const handleClearFilter = (key: keyof FilterState) => {
        setFilters((prev: FilterState) => ({
            ...prev,
            [key]: [],
        }));
    };

    const handleResetFilters = () => {
        setFilters({});
    };

    return (
        <SidebarFiltersList
            isOpen={isOpen ?? false}
            onClose={onClose}
            categoriesById={categoriesById}
            beerStylesById={beerStylesById}
            vendorsById={vendorsById}
            packagingTypesById={packagingTypesById}
            volumesById={volumesById}
            filters={filters}
            onToggleFilter={handleToggleFilter}
            onClearFilter={handleClearFilter}
            onResetFilters={handleResetFilters}
            onSetFilters={setFilters}
            onApply={onApply}
        />
    );
}
